import React from 'react';
import { FormControl, FormLabel, Checkbox, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const ActiveCheckbox = ({ value, onChange }) => {
  const labelColor = useColorModeValue('black', 'white');
    const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl>
      <Tooltip label="Toggle whether this rate is active. Unchecking will delete this rate." placement="top">
        <FormLabel  color={darkMode ? 'white' : 'black'}>Active</FormLabel>
      </Tooltip>
      <Checkbox  style={{ accentColor: darkMode ? '#3182ce' : undefined }}name="isActive" isChecked={value} onChange={onChange} colorScheme="whatsapp">
        Uncheck to delete
      </Checkbox>
    </FormControl>
  );
};

export default ActiveCheckbox;
